import React, { Component } from 'react';
import { connect } from 'react-redux';

import ArticleTable from '../components/ArticleTable';
import { selectors } from '../reducers/itemsReducer';
import * as filterSelectors from '../selectors/filterSelectors'
import { selectors as collectionsSelectors } from '../reducers/collectionsReducer';
import { selectors as userSelectors } from '../reducers/userReducer';
import { selectors as appSelectors } from '../reducers/appReducer';
import { actions } from '../actions/itemsActions';
import { actions as collectionsActions } from '../actions/collectionsActions';
import { actions as appActions } from '../actions/appActions';
import * as constants from '../constants';

export class ArticleTableContainer extends Component {
    render() {
        return <ArticleTable {...this.props} />;
    }
}

function mapStateToProps(state) {
    // const isCollectionEngaged = collectionsSelectors.getEngagedCollection(state) !== null;

    return {
        isFetching: selectors.getIsFetching(state),
        productProperties: appSelectors.getProductProperties(state),
        items: selectors.getItems(state),
        customItems: selectors.getCustomItems(state).toJS(),
        // customItems: isCollectionEngaged
        //     ? selectors.getCustomItemsWithCollections(state).toJS()
        //     : selectors.getCustomItems(state).toJS(),
        total: selectors.getItemsTotal(state),
        serverTotal: selectors.getItemsServerTotal(state),
        q: filterSelectors.getFilter(state, constants.FULL_TEXT_FILTER).value,
        sorting: selectors.getSorting(state),
        currentPage: selectors.getCurrentPage(state),
        pages: selectors.getPagesTotal(state),
        lastSearchHash: selectors.getLastSearchHash(state),
        selectedItems: selectors.getSelectedItems(state),
        // areRowsSelectable: isCollectionEngaged,
        // user: userSelectors.getUser(state),
        language: appSelectors.getLanguage(state),
        isAnyFilterActive: filterSelectors.isAnyFilterActive(state),
        defaultTableView: appSelectors.getDefaultTableView(state),
        currentViewType: appSelectors.getCurrentViewType(state),
        listiniFilter: filterSelectors.getFilter(state, constants.LISTINI_FILTER),
        brandFilter: filterSelectors.getFilter(state, constants.BRAND_FILTER),
        selectAllChecked: selectors.getSelectAllChecked(state),
        collectionShownId: collectionsSelectors.getShownCollection(state),
        showLists: appSelectors.getShowLists(state),
        priceDecimalPrecision: appSelectors.getPriceDecimalPrecision(state),
        deleteProductsGrant: userSelectors.getUserGrant(state, 'delete_products'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        sortBy(attr) {
            dispatch(actions.sortBy(attr));
        },
        onPageChange(page) {
            dispatch(actions.changePage(page));
        },
        onSelectRow(id) {
            dispatch(actions.toggleSelectedItem(id));
        },
        onSelectAll() {
            dispatch(actions.toggleAllSelectedItems());
        },
        onRemoveAll() {
            dispatch(collectionsActions.removePagedItemsFromCollection());
        },
        onSetViewType(viewType) {
            dispatch(appActions.changeCurrentTableView(viewType));
        },
        dispatch,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleTableContainer);
